import React, {useState, useEffect} from "react";

const StudentSettingsDesktopTabs= ({setActiveTab, activeTab, handleSubscriptionClick, handleOpenDisputeClick}) => {
    
    return (
        <div className="hidden lg:flex w-full h-[300px] justify-center items-center "
            style={{ background: "linear-gradient(70deg, #170654 0%, #440F88 100%)" }}>
           <div className="w-[75%] h-fit flex flex-col gap-[70px] mt-[120px] ">
                <p className="text-[45px] font-bold text-[#FFFFFF] ">Setting</p>
                <div className="w-full flex gap-[90px]">
                    <div className="flex flex-col gap-[2px] cursor-pointer">
                        <p className={`text-[20px] text-[#FFFFFF]`}
                        onClick={() => setActiveTab("profile")}>
                            Profile
                        </p>
                        { activeTab === "profile" && (
                            <div className="h-[7px] bg-[#A1A3EF]">
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col gap-[2px] cursor-pointer">
                        <p className={`text-[20px] text-[#FFFFFF]`}
                        onClick={() => setActiveTab("Account Security")}>
                            Account Security
                        </p>
                        { activeTab === "Account Security" && (
                            <div className="h-[7px] bg-[#A1A3EF]">
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col gap-[2px] cursor-pointer">
                        <p className={`text-[20px] text-[#FFFFFF]`}
                        onClick={handleSubscriptionClick}>
                            Subscriptions
                        </p>
                        { activeTab === "Subscriptions" && (
                            <div className="h-[7px] bg-[#A1A3EF]">
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col gap-[2px] cursor-pointer">
                        <p className={`text-[20px] text-[#FFFFFF]`}
                       onClick={() => setActiveTab("Notifications")}>
                            Notifications
                        </p>
                        { activeTab === "Notifications" && (
                            <div className="h-[7px] bg-[#A1A3EF]">
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col gap-[2px] cursor-pointer">
                        <p className={`text-[20px] text-[#FFFFFF]`}
                        onClick={handleOpenDisputeClick}>
                            Open Dispute
                        </p>
                        { activeTab === "Open Dispute" && (
                            <div className="h-[7px] bg-[#A1A3EF]">
                            </div>
                        )}
                    </div>

                </div>
           </div>
        </div>
    );
};

export default StudentSettingsDesktopTabs;
